import GuideList from '@/components/app/programV2/ProgramInfo/GuideList';
import ProgramNarrator from '@/components/app/programV2/ProgramInfo/ProgramNarrator';
import ProgramPlayActions from '@/components/app/programV2/ProgramInfo/ProgramPlayActions';
import Image from '@/components/image/NextImage';
import { useProgramInfo } from '@/hooks/app/useProgramInfo';
import { useProgramState } from '@/hooks/store';
import { formatResizedUrl } from '@/utils/app/formatResizedUrl';

import ProgramActions from './ProgramActions';
import {
	ContentType,
	Description,
	HorizontalLine,
	ImageWrapper,
	OverviewWrapper,
	Title,
	Wrapper,
} from './styles';

const ProgramInfo = () => {
	const program = useProgramState();
	const { image } = useProgramInfo();

	if (!program) {
		return null;
	}

	return (
		<Wrapper>
			<OverviewWrapper>
				<div>
					<ContentType>{program.content_type}</ContentType>
					<Title tabIndex={-1}>{program.title}</Title>
					<Description>{program.description}</Description>
				</div>
				<ProgramNarrator program={program} />
				<ProgramPlayActions />
				<HorizontalLine />
				<ProgramActions />
				<GuideList program={program} />
			</OverviewWrapper>
			{image && (
				<ImageWrapper>
					<Image src={formatResizedUrl(image.url, 294)} alt="" layout="fill" objectFit="cover" />
				</ImageWrapper>
			)}
		</Wrapper>
	);
};

export default ProgramInfo;
